export const ChevronLeftSVG = ({
    className,
    fill
}: {
    className?: string;
    fill?: string;
}) => (
    <svg
        className={className}
        data-testid="chevron-left-icon"
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.80561 0.21967L1.03264 4.99264C0.739743 5.28553 0.739743 5.76041 1.03264 6.0533L5.80561 10.8263C6.0985 11.1192 6.57337 11.1192 6.86627 10.8263C7.15916 10.5334 7.15916 10.0585 6.86627 9.76561L2.62363 5.52297L6.86627 1.28033C7.15916 0.987437 7.15916 0.512563 6.86627 0.21967C6.57337 -0.0732234 6.0985 -0.0732234 5.80561 0.21967Z"
            fill={fill ? fill : '#246AC1'}
        />
    </svg>
);
